// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.articlesContent_M_o23 {
  display: flex;
  flex-direction: column;

  ul {
    margin: 0;
  }
  .article_b94fe {
    .articleTitle_EFtBm,
    .articleInfo_XGMki {
      color: #1a1a1a;
      font-weight: 400;
    }
    .articleTitle_EFtBm {
      margin: 15px 0;
      font-weight: 300;
      cursor: pointer;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      svg{
        transform: rotate(-90deg);
        -webkit-transform: rotate(-90deg);
        -moz-transform: rotate(-90deg);
        -ms-transform: rotate(-90deg);
        -o-transform: rotate(-90deg);
}
    }
    .articleInfo_XGMki {
      margin: 20px 0;
      interpolate-size: allow-keywords;
      transition:  all 300ms;
      -webkit-transition:  all 300ms;
      -moz-transition:  all 300ms;
      -ms-transition:  all 300ms;
      -o-transition:  all 300ms;
}
  }
}

.YourAccountConfigIcons_fkoh5{
    display: flex;
    align-items: center;
    gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/HelpPage/YourAccount/YourAccount.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;;EAEtB;IACE,SAAS;EACX;EACA;IACE;;MAEE,cAAc;MACd,gBAAgB;IAClB;IACA;MACE,cAAc;MACd,gBAAgB;MAChB,eAAe;MACf,WAAW;MACX,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B;QACE,yBAAyB;QACzB,iCAAiC;QACjC,8BAA8B;QAC9B,6BAA6B;QAC7B,4BAA4B;AACpC;IACI;IACA;MACE,cAAc;MACd,gCAAgC;MAChC,sBAAsB;MACtB,8BAA8B;MAC9B,2BAA2B;MAC3B,0BAA0B;MAC1B,yBAAyB;AAC/B;EACE;AACF;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb","sourcesContent":[".articlesContent {\n  display: flex;\n  flex-direction: column;\n\n  ul {\n    margin: 0;\n  }\n  .article {\n    .articleTitle,\n    .articleInfo {\n      color: #1a1a1a;\n      font-weight: 400;\n    }\n    .articleTitle {\n      margin: 15px 0;\n      font-weight: 300;\n      cursor: pointer;\n      width: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      svg{\n        transform: rotate(-90deg);\n        -webkit-transform: rotate(-90deg);\n        -moz-transform: rotate(-90deg);\n        -ms-transform: rotate(-90deg);\n        -o-transform: rotate(-90deg);\n}\n    }\n    .articleInfo {\n      margin: 20px 0;\n      interpolate-size: allow-keywords;\n      transition:  all 300ms;\n      -webkit-transition:  all 300ms;\n      -moz-transition:  all 300ms;\n      -ms-transition:  all 300ms;\n      -o-transition:  all 300ms;\n}\n  }\n}\n\n.YourAccountConfigIcons{\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"articlesContent": `articlesContent_M_o23`,
	"article": `article_b94fe`,
	"articleTitle": `articleTitle_EFtBm`,
	"articleInfo": `articleInfo_XGMki`,
	"YourAccountConfigIcons": `YourAccountConfigIcons_fkoh5`
};
export default ___CSS_LOADER_EXPORT___;
